/*--------------------------------------------------------------
#Functions
--------------------------------------------------------------*/
import * as Footer from '../functions/Footer.js';

/*--------------------------------------------------------------
#Components
--------------------------------------------------------------*/
import '../components/Accordian1A.js';
import '../components/Carousel1A.js';
import '../components/Carousel1B.js';
import '../components/GridContent1B.js';
import '../components/Carousel1C.js';
import '../components/Form1A.js';
import '../components/LoadMore1A.js';
import '../components/Navigation1A.js';
import '../components/Navigation2A.js';
import '../components/Navigation3A.js';
import '../components/Navigation4A.js';

/*--------------------------------------------------------------
#Pages
--------------------------------------------------------------*/
import '../pages/JCSLOptIn.js';


$(window).on('resize load', function() {
    Footer.SetGap('.footer-gap', '.site-footer');
});
$(function() {
    var WaypointsWindowOffset = $('.on-watch-window-offset').waypoint(function(direction) {
        var $ref = $($(this)[0].element);
        var $element = ($ref.attr('data-wo-element')) ? $($ref.attr('data-wo-element')) : $ref;
        var $follow = $ref.attr('data-wo-follow');
    
        $element.addClass('on-watch-window-offset--active');
        ($follow && direction == 'up') && $element.removeClass('on-watch-window-offset--active');
    }, {
        offset:'100%'
    });
    var WaypointsElementOffset = $('.on-watch-element-offset').waypoint(function(direction) {
        var $ref = $($(this)[0].element);
        var $element = ($ref.attr('data-eo-element')) ? $($ref.attr('data-eo-element')) : $ref;
        var $follow = $ref.attr('data-eo-follow');
    
        $element.addClass('on-watch-element-offset--active');
        ($follow && direction == 'up') && $element.removeClass('on-watch-element-offset--active');
    }, {
        offset: function() {
            var $element = $($(this)[0].element);
            return $element.attr('data-eo-offset');
        }
    });

    window._wq = window._wq || [];
    var videoOptionsApplication = {
        popover: true,
        //popoverPreventScroll: true,
    };
    _wq.push({ id:"_all", options:videoOptionsApplication, onReady: function(video) {
        var videoHashedId = video.hashedId();
        var $videoTrigger = $('[data-ws-hashedid="'+videoHashedId+'"]');
        $videoTrigger.on('click', {video:video}, function(event) {
            var theVideo = event.data.video;
            theVideo.play();
        });
        $videoTrigger.attr( "data-ws-status", "ready" )
    }});
});
